
import './IgongChartDetail.scss';
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';
import React, { useState, useEffect } from 'react';

const IgongChartDetail = ({data}) => {

    const [list, setList] = useState([]);


    useEffect(() => {

        if (data.length > 0) {
            fncSelect_list(data[0].cntA, data[0].cntB ,data[0].cntE, data[0].cntF);
            console.log(data, ' chart detail data');
        }

    }, []);
        
    function fncSelect_list(A, B ,E, F) {

        console.log(A, B ,E, F, 'A, B ,E, F');
        fnc.sendAxios('/igongAssess_chart/detail/select/momChartDetail', { 
            A, B ,E, F }, (res) => {
            if (res && Array.isArray(res)) {
                console.log(res, '============ res');
                const newList = getRecords(res);
                setList(newList);
            } else {
            alert('검색에 실패했습니다.');
            }
        });

        function getRecords(res) {
            const records = [];
            res.forEach(item => {
            const sno = item["no"];
            const unit1 = item["unit1"];
            const unit2 = item["unit2"];
            const content = item["content"];
            records.push({ sno, unit1, unit2, content });
            });
            return records;
        }

    }
   
    

//=========================================
  return (
    <div className='IgongChartDetail'>
        <article className='art-main'>
            <div className='box-title'>
                <span className='title1'>학부모 유형분석</span>
                <span className='title2'>{list[0]?.unit1}</span>
                <span className='title3'>({list[0]?.unit2})</span>
            </div>
            <p className='content'>{list[0]?.content}</p>
        </article>

    </div>
  );
};

export default IgongChartDetail;